import { API_HOST } from "./config"
export default {
  // ADMIN ROUTES
  ADMIN_REVIEWS: `${API_HOST}admin/rating/all_ratings`,
  ADMIN_REVIEWS_TOP_BANNERS: `${API_HOST}admin/rating/top_banners_ratings`,
  ADMIN_DELETE_REVIEW: `${API_HOST}admin/rating/delete_review`
}
